module.exports = __webpack_public_path__ + "static/fonts/NanumGothic-ExtraBold.40dde29.eot";